"use strict";

exports.__esModule = true;
exports.stripHtml = void 0;

const stripHtml = value => typeof value === 'string' ? value.replace(/<[^>]+>/g, '') : value;

exports.stripHtml = stripHtml;